import {
  TopicflowIcon,
  TopicflowIconType,
} from "@components/topicflow-icon/topicflow-icon";
import { classNames } from "@helpers/css";
import { titleCase } from "@helpers/string";

// https://www.figma.com/design/dymXErIH2py1VGxqmBjNN6/-Design-Master--Component-Library?node-id=4903-25439&m=dev
const Callout = ({
  children,
  center = false,
  theme = "default",
  icon,
  className,
  size = "default",
  title,
}: {
  children: React.ReactNode;
  center?: boolean;
  theme?: "default" | "warning" | "success" | "transparent";
  icon?: TopicflowIconType;
  className?: string;
  size?: "small" | "default";
  title?: string;
}) => {
  return (
    <div
      className={classNames(
        "flex gap-3 rounded-md text-gray-600",
        theme === "default" && "bg-gray-100",
        theme === "warning" && "bg-amber-100",
        theme === "success" && "bg-emerald-50",
        center && "justify-center flex-col items-center",
        center && size === "small" && "gap-2",
        size === "default" && "p-4",
        size === "small" && "py-2 px-3",
        className
      )}
    >
      {icon && (
        <TopicflowIcon
          type={icon}
          className={classNames(
            size === "default" && center ? "w-5 h-5" : "w-4 h-4",
            "mt-0.5", // align with text
            theme === "default" || (theme === "transparent" && "text-gray-600"),
            theme === "warning" && "text-amber-600",
            theme === "success" && "text-emerald-700"
          )}
        />
      )}
      {center ? (
        <div className="flex flex-col items-center gap-1 text-center">
          {title && <div className="tf-header-sm-dark">{titleCase(title)}</div>}
          <div className="flex flex-col gap-4 items-center">{children}</div>
        </div>
      ) : (
        <div>
          {title && (
            <div className="tf-header-sm-dark mb-1">{titleCase(title)}</div>
          )}
          {children}
        </div>
      )}
    </div>
  );
};

export default Callout;
